





























/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { CurationTodoDTO, StreamStatsDTO, ContentStreamDTOStatus, StreamStatsDTOStatus } from "../../Generated/ParticaAPI";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
import { DateUtils } from "../../BusinessServices/dateutils";
@Component(
	{
		name: "ContentStreamStats"
	})
export default class ContentStreamStats extends Vue {
	@Prop() private streams: StreamStatsDTO[];
	private search: string = "";
	private headers: any = [
		{
			text: "Stream",
			align: "left",
			value: "name"
		},
		{ text: "Status", value: "status" },
		{ text: "Last Issue", value: "lastIssue" },
		{ text: "Last Issue Date", value: "lastIssueDate", align: "left" },
		{ text: "Next Issue", value: "nextIssueDate", align: "left" },
		{ text: "Active Subscribers", value: "subscribers", align: "left" },
		{ text: "Visibility", value: "visibility" },
	];

	private getFormat(date: Date) {
		if (DateUtils.CompareDate(date, new Date("0001-01-01T00:00:00Z"))) {
			return "Unknown";
		}
		return date.toDateString();
	}

	private gotoStream(item: StreamStatsDTO) {
		this.$emit("partica-event", { action: eParticaAction.CONTENT_STREAM_SELECT_STREAM, item } as ParticaEvent);
	}

	private getStatusColor(stream: StreamStatsDTO): string {
		if (stream.status === StreamStatsDTOStatus.Inactive) {
			return "#ffb3b3";
		}
		return "white";
	}
	private getNextDateColor(stream: StreamStatsDTO): string {
		const duration: number = (stream.nextIssueDate as Date).valueOf() - new Date().valueOf();
		const days: number = duration / (3600000 * 24);
		if (days < 1) {
			return "#D50000";
		}
		if (days < 5) {
			return "#FFA726";
		}
		return "white";
	}
}
